var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useContext } from 'react';
import styled, { css, ThemeContext } from 'styled-components';
import { TextSizeType } from '../../../../shared/styling/BaseText/BaseText.enum';
import Container from '../../../Atoms/Container/Container';
import Text from '../../../Atoms/Text/Text';
import BaseInput from '../BaseComponents/BaseInputText';
import BaseInputTextContainer from '../BaseComponents/BaseInputTextContainer';
const RightSlotWrapper = styled.div `
  margin-right: 16px;
`;
const ValidationText = styled(Text) `
  ${({ hasValidationTextBlock, hasText }) => hasValidationTextBlock &&
    css `
      display: block;
      height: 20px; // same as line-height of Text component
      visibility: ${hasText ? 'visible' : 'hidden'};
    `}

  ${({ hasValidationTextBlock, hasText }) => !hasValidationTextBlock &&
    css `
      display: ${hasText ? 'block' : 'none'};
    `}
`;
const InputText = forwardRef((_a, ref) => {
    var { type, multiline, name, readOnly, disabled, error, errorText, touched, icon, label, helperText, customCss, iconPosition, rightSlot, hasValidationTextBlock = false } = _a, delegated = __rest(_a, ["type", "multiline", "name", "readOnly", "disabled", "error", "errorText", "touched", "icon", "label", "helperText", "customCss", "iconPosition", "rightSlot", "hasValidationTextBlock"]);
    const theme = useContext(ThemeContext);
    return (_jsxs(Container, Object.assign({}, (customCss && { customCss }), { noPadding: true }, { children: [label && (_jsx(Text, Object.assign({ as: "label", htmlFor: name, textSize: TextSizeType.TEXT16 }, { children: label }), void 0)), _jsxs(BaseInputTextContainer, Object.assign({ disabled: disabled, error: touched && error, iconPosition: iconPosition, readOnly: readOnly }, { children: [_jsx(BaseInput, Object.assign({ ref: ref, as: multiline ? 'textarea' : 'input', disabled: disabled, id: name, name: name, readOnly: readOnly, type: type || 'text' }, delegated), void 0), rightSlot && _jsx(RightSlotWrapper, { children: rightSlot }, void 0), icon || null] }), void 0), helperText ? (_jsx(Text, Object.assign({ color: theme.colorsV2.grayscale.gray60, textSize: TextSizeType.TEXT14 }, { children: helperText }), void 0)) : null, _jsx(ValidationText, Object.assign({ color: theme.colorsV2.ui.support.danger, hasText: !!error && !!errorText, hasValidationTextBlock: hasValidationTextBlock, textSize: TextSizeType.TEXT14 }, { children: errorText }), void 0)] }), void 0));
});
export default InputText;
//# sourceMappingURL=InputText.js.map